import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=26017633&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports